'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeViewer$Props(recipe, date, scaleToServings) {
  this.LS = null;
  this.SG = null;
  this.SH = null;
  this.LS = recipe;
  this.SG = date;
  this.SH = scaleToServings;
}
export { $c_Lmealorama_components_RecipeViewer$Props as $c_Lmealorama_components_RecipeViewer$Props };
$p = $c_Lmealorama_components_RecipeViewer$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeViewer$Props;
/** @constructor */
function $h_Lmealorama_components_RecipeViewer$Props() {
}
export { $h_Lmealorama_components_RecipeViewer$Props as $h_Lmealorama_components_RecipeViewer$Props };
$h_Lmealorama_components_RecipeViewer$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_RecipeViewer$Props)) {
    var x = this.LS;
    var x$2 = x$0.LS;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.SG;
      var x$4 = x$0.SG;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.SH;
      var x$6 = x$0.SH;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.LS;
      break;
    }
    case 1: {
      return this.SG;
      break;
    }
    case 2: {
      return this.SH;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_RecipeViewer$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kj)));
}
export { $isArrayOf_Lmealorama_components_RecipeViewer$Props as $isArrayOf_Lmealorama_components_RecipeViewer$Props };
var $d_Lmealorama_components_RecipeViewer$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeViewer$Props, "mealorama.components.RecipeViewer$Props", ({
  kj: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_RecipeViewer$Props as $d_Lmealorama_components_RecipeViewer$Props };
//# sourceMappingURL=mealorama.components.-Recipe-Viewer$-Props.js.map
